import {
  Box,
  Button,
  Flex,
  Text,
  ButtonGroup,
  Grid,
  GridItem,
  Textarea,
  Input,
  TableContainer,
  Table,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverHeader,
  PopoverBody,
  PopoverFooter,
  PopoverArrow,
  PopoverCloseButton,
  PopoverAnchor,
  Portal,
  VisuallyHidden,
  Tooltip,
  Badge,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Link,
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import {
  FileIcon,
  RemoveIcon,
  CommentBlackIcon,
  CommentIcon,
  Loader,
} from "../../assets/svgs/Icons";
import {
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogBody,
  AlertDialogFooter,
} from "@chakra-ui/react";
import { useDisclosure } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { FiUpload } from "react-icons/fi";
import { useParams } from "react-router-dom";
import { CheckIcon } from "@chakra-ui/icons";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import axios from "axios";
import isAllowed from "../../routing/isAllowed";
import RC from "../../Components/Certificates/RC";
import { IoChevronBackCircleSharp } from "react-icons/io5";
import { DocumentViewer } from "../../Components/common/DocumentViewer";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { toast } from "react-toastify";
import { getInventoryDetails } from "./InventorySlice";

function InventoryDetails() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [comment, setComment] = useState("");
  const [remark, setRemark] = useState(""); //final remark at end of form
  const [status, setStatus] = useState("idle");
  const [showPreview, setShowPreview] = useState(false);
  const dispatch = useDispatch();
  const { id } = useParams();
  ;
  const { details } = useSelector((state) => state.inventory);
  const [checklistFile, setChecklistFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();
  const { userData } = useSelector((state) => state.auth);

  const getDetails = () => {
    try {
      setStatus("pending");
      dispatch(getInventoryDetails(id));
      setStatus("success");
    } catch (error) {
      setStatus("failed");
    }
  };

  useEffect(() => {
    getDetails();
  }, []);

  const handleGoBack = () => {
    navigate(-1);
  };

  ;
  return (
    <Box marginBottom={"2rem"} padding="3rem" w={"100%"}>
      <Box
        display={"flex"}
        alignItems="center"
        cursor={"pointer"}
        marginBottom="2rem"
        onClick={handleGoBack}
      >
        <IoChevronBackCircleSharp color={"#52BBFF"} size={30} />
        &nbsp;
        <Text
          //#3958DC
          color={"#52BBFF"}
          fontSize={{ base: "sm", md: "sm", lg: "md" }}
          fontWeight={"800"}
          fontFamily={"font.roboto"}
        >
          Go Back
        </Text>
      </Box>
      <Box marginTop="2rem">
        <Text
          color={"#141D43"}
          fontSize="2xl"
          fontWeight={"800"}
          fontFamily={"font.roboto"}
        >
          Inventory
        </Text>
      </Box>
      <Box
        marginTop={"1.5rem"}
        color={"#fff"}
        padding={"10px 2rem"}
        fontWeight="700"
        marginLeft="-5rem"
        marginRight={"-5rem"}
        bg={
          "linear-gradient(90deg, rgba(81,187,255,1) 0%, rgba(81,187,255,1) 15%, rgba(164,206,255,1) 100%)"
        }
        borderTopRightRadius="100px"
        borderBottomRightRadius={"80px 80px"}
      >
        Inventory Details # {details?.id}
      </Box>
      <Box
        bg="#fff"
        padding={"2rem"}
        marginTop="2rem"
        borderRadius={"15px"}
        boxShadow={"rgba(100, 100, 111, 0.2) 0px 10px 26px 0px"}
      >
        <Text color={"#141D43"} fontSize="lg" fontWeight={"800"}>
          <Box
            as="span"
            borderRight={"3px solid #2272D5"}
            height="40px"
            marginRight={"1rem"}
          ></Box>
          Inventory Details
        </Text>
        <Box paddingLeft={"3rem"}>
          <Box>
            <Grid
              alignItems={"flex-end"}
              gap={"3rem"}
              templateColumns="repeat(2, 1fr)"
              marginTop={"1rem"}
            >
              <Box
                display={"flex"}
                flexDirection="column"
                alignItems="flex-start"
                justifyContent={"center"}
              >
                <Grid
                  width={"100%"}
                  templateColumns="repeat(2, 1fr)"
                  my={"1rem"}
                  gap="3rem"
                >
                  <Grid
                    width={"100%"}
                    templateColumns="repeat(2, 1fr)"
                    my={"1rem"}
                    gap="3rem"
                  >
                    <GridItem width={"100%"}>
                      <Text
                        color={"#141D43"}
                        fontSize="md"
                        fontWeight={"700"}
                        fontFamily={"font.roboto"}
                      >
                        Name of Organisational Unit
                      </Text>

                      <Text color={" #464C64"} fontSize="sm" marginTop={"1rem"}>
                        {details?.inventory_unit?.name}
                      </Text>
                    </GridItem>
                    <GridItem width={"100%"}>
                      <Text
                        color={"#141D43"}
                        fontSize="md"
                        fontWeight={"700"}
                        fontFamily={"font.roboto"}
                      >
                        Unit Type
                      </Text>

                      <Text color={" #464C64"} fontSize="sm" marginTop={"1rem"}>
                        {details?.inventory_unit?.unitType}
                      </Text>
                    </GridItem>
                  </Grid>
                </Grid>
                <GridItem width={"100%"}>
                  <Text
                    color={"#141D43"}
                    fontSize="md"
                    fontWeight={"700"}
                    fontFamily={"font.roboto"}
                  >
                    Address
                  </Text>

                  <Text color={" #464C64"} fontSize="sm" marginTop={"1rem"}>
                    {details?.inventory_unit?.address?.raw_address}
                  </Text>
                </GridItem>
                <Grid
                  width={"100%"}
                  templateColumns="repeat(2, 1fr)"
                  my={"1rem"}
                  gap="3rem"
                >
                  <GridItem>
                    <Text
                      color={"#141D43"}
                      fontSize="md"
                      fontWeight={"700"}
                      fontFamily={"font.roboto"}
                    >
                      City
                    </Text>

                    <Text color={" #464C64"} fontSize="sm" marginTop={"1rem"}>
                      {details?.inventory_unit?.address?.city}
                    </Text>
                  </GridItem>
                  <GridItem>
                    <Text
                      color={"#141D43"}
                      fontSize="md"
                      fontWeight={"700"}
                      fontFamily={"font.roboto"}
                    >
                      State
                    </Text>

                    <Text color={" #464C64"} fontSize="sm" marginTop={"1rem"}>
                      {details?.inventory_unit?.address?.state}
                    </Text>
                  </GridItem>
                </Grid>
                <Grid
                  width={"100%"}
                  templateColumns="repeat(2, 1fr)"
                  my={"1rem"}
                  gap="3rem"
                >
                  <GridItem>
                    <Text
                      color={"#141D43"}
                      fontSize="md"
                      fontWeight={"700"}
                      fontFamily={"font.roboto"}
                    >
                      Pincode
                    </Text>

                    <Text color={" #464C64"} fontSize="sm" marginTop={"1rem"}>
                      {details?.inventory_unit?.address?.pinCode}
                    </Text>
                  </GridItem>
                  <GridItem>
                    <Text
                      color={"#141D43"}
                      fontSize="md"
                      fontWeight={"700"}
                      fontFamily={"font.roboto"}
                    >
                      Country
                    </Text>

                    <Text color={" #464C64"} fontSize="sm" marginTop={"1rem"}>
                      {details?.inventory_unit?.address?.country}
                    </Text>
                  </GridItem>
                </Grid>
              </Box>
            </Grid>
          </Box>
        </Box>
        <Text
          color={"#141D43"}
          fontSize="lg"
          fontWeight={"800"}
          marginBottom="5px"
        >
          Product Details
          <Box
            border={"2px solid #2272D5"}
            width="10%"
            marginBottom={"1rem"}
          ></Box>
        </Text>
        <Box paddingLeft={"3rem"}>
          <Box>
            <Grid
              alignItems={"flex-end"}
              gap={"3rem"}
              templateColumns="repeat(2, 1fr)"
              marginTop={"1rem"}
            >
              <Box
                display={"flex"}
                flexDirection="column"
                alignItems="flex-start"
                justifyContent={"center"}
              >
                <Grid
                  width={"100%"}
                  templateColumns="repeat(3, 1fr)"
                  my={"1rem"}
                  gap="3rem"
                >
                  <GridItem>
                    <Text
                      color={"#141D43"}
                      fontSize="md"
                      fontWeight={"700"}
                      fontFamily={"font.roboto"}
                    >
                      Product Classification
                    </Text>

                    <Text color={" #464C64"} fontSize="sm" marginTop={"1rem"}>
                      {details?.inventory_productClassification?.name}
                    </Text>
                  </GridItem>
                  <GridItem>
                    <Text
                      color={"#141D43"}
                      fontSize="md"
                      fontWeight={"700"}
                      fontFamily={"font.roboto"}
                    >
                      Program Applied for
                    </Text>

                    <Text color={" #464C64"} fontSize="sm" marginTop={"1rem"}>
                      {details?.inventory_program?.name}
                    </Text>
                  </GridItem>
                  {/* <GridItem>
                      <Text
                        color={"#141D43"}
                        fontSize="md"
                        fontWeight={"700"}
                        fontFamily={"font.roboto"}
                      >
                        Email
                      </Text>
  
                      <Text color={" #464C64"} fontSize="sm" marginTop={"1rem"}>
                      </Text>
                    </GridItem> */}
                </Grid>
              </Box>
            </Grid>
          </Box>
        </Box>
        <Text
          color={"#141D43"}
          fontSize="lg"
          fontWeight={"800"}
          marginBottom="5px"
        >
          Procurement Details
        </Text>
        <Box
          border={"2px solid #2272D5"}
          width="10%"
          marginBottom={"1rem"}
        ></Box>
        <Box paddingLeft={"3rem"}>
          <Box>
            <Grid
              alignItems={"flex-end"}
              gap={"3rem"}
              templateColumns="repeat(2, 1fr)"
              marginTop={"1rem"}
            >
              <Box
                display={"flex"}
                flexDirection="column"
                alignItems="flex-start"
                justifyContent={"center"}
              >
                <Grid
                  width={"100%"}
                  templateColumns="repeat(3, 1fr)"
                  my={"1rem"}
                  gap="3rem"
                >
                  <GridItem>
                    <Text
                      color={"#141D43"}
                      fontSize="md"
                      fontWeight={"700"}
                      fontFamily={"font.roboto"}
                    >
                      Quantity Approved
                    </Text>

                    <Text color={" #464C64"} fontSize="sm" marginTop={"1rem"}>
                      {details?.quantityReceived} {"Kg"}
                    </Text>
                  </GridItem>
                </Grid>
              </Box>
            </Grid>
          </Box>
        </Box>
        <Text
          color={"#141D43"}
          fontSize="lg"
          fontWeight={"800"}
          marginBottom="5px"
        >
          Transaction Details
        </Text>
        <Box
          border={"2px solid #2272D5"}
          width="10%"
          marginBottom={"1rem"}
        ></Box>
        {details?.tcNoOfInward ? (
          <Grid
            templateColumns="repeat(1, 1fr)"
            style={{ paddingLeft: "0 !important" }}
            width={"100%"}
          >
            <GridItem
              width={"100%"}
              overflowY="auto"
              maxHeight="300px"
              className="overflow-style"
              boxShadow={"rgba(100, 100, 111, 0.2) 0px 10px 26px 0px"}
            >
              <TableContainer className="overflow-style">
                <Table
                  variant={"simple"}
                  size="md"
                  bg={"#fff"}
                  borderRadius={"15px"}
                  pr={"1rem"}
                >
                  <Thead>
                    <Tr>
                      <Th color="brand.blue" textTransform="capitalize">
                        srNo .
                      </Th>
                      <Th color="brand.blue" textTransform="capitalize">
                        Consumed In TC
                      </Th>
                      <Th color="brand.blue" textTransform="capitalize">
                        Consumed Quantity
                      </Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {details?.tcNoOfInward?.length ? (
                      details?.tcNoOfInward?.map((remark, index) => {
                        return (
                          <Tr>
                            <Td>{index + 1}</Td>
                            <Td>
                              {remark?.consumedInTc || remark?.tcId?.tcNumber
                                ? remark?.consumedInTc || remark?.tcId?.tcNumber
                                : "N/A"}
                            </Td>
                            <Td>
                              {remark?.consumedQnt || remark?.quantity
                                ? remark?.consumedQnt || remark?.quantity
                                : "N/A"}
                            </Td>
                          </Tr>
                        );
                      })
                    ) : (
                      <Tr>
                        <Td colSpan="4" textAlign="center" fontWeight={"700"}>
                          No Transaction Details for now
                        </Td>
                      </Tr>
                    )}
                  </Tbody>
                </Table>
              </TableContainer>
            </GridItem>
          </Grid>
        ) : (
          ""
        )}
      </Box>
    </Box>
  );
}

export default isAllowed(InventoryDetails)
